/**
 * Return gtm classes for bookmark button
 * @param  {Bool} is poi already marked
 * @return {String}        Class names
 */
export function bookmarkButtonGtmClasses(marked) {
  const gtmClass = "js-gtm-bookmark-button";
  return `${gtmClass} ${gtmClass + (marked ? "-remove" : "-add")}`;
}



// WEBPACK FOOTER //
// ./assets/pois/utils/gtm.js